import React, { createContext, useContext, useState } from "react";

// Create a context for user data
const UserContext = createContext();

// Custom hook to access user data
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

// Provider component to wrap the app
export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dobDay: "",
    dobMonth: "",
    dobYear: "",
    email: "",
    phone: "",
    address: "",
    collegeName: "",
    graduationYear: "",
    degree: "",
    department: "",
    studentId: "",
  });

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
};
